"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var forEachPolyfill = function forEachPolyfill() {
  // eslint-disable-next-line no-undef
  NodeList.prototype.forEach = Array.prototype.forEach;
};

var _default = forEachPolyfill;
exports.default = _default;